module Meevo.Plugins.Client {
    "use strict";
    import SaleTypeFilterEnum = Meevo.Model.SaleTypeFilterEnum;
    import SortDirection = Meevo.Model.SortDirection;


    export interface ITransactionHistoryFilters {
        saleTypeFilterEnum?: SaleTypeFilterEnum;
        locationId?: number;
        isGlobal: boolean;
        filterLastTwoYears: boolean;
        membershipPackagesOnly?: boolean;
        transitionStates?: Model.AppointStateEnum[];
        finalStates?: Model.AppointFinalStateEnum[];
        startDate?: Date;
        endDate?: Date;
    }

    export interface ITransactionHistoryRequest {
        criteria?: ITransactionHistoryFilters;
        clientGlobalId?: Guid;
        sortDirection: SortDirection;
        itemsPerPage: number;
        includeAssociatedSales?: boolean,
    }

    export enum PrintTypeEnum {
        Receipt,
        GiftReceipt,
        InsuranceReceipt
    }

    export enum TabViewEnum {
        TransactionView,
        DiscountView,
        ImportedView
    }

    export enum ClientHistoryType {
        AppointmentHistory = 1,
        TransactionHistory = 2,
        PackageHistory = 3,
        GiftCardHistory = 4,
        AccountActivity = 5
    }


    export enum PackageType {
        All,
        Active,
        Expirednobalance,
        ExpiredWithBalance,
        NoBalance,
        SplitMerge,
        Membership
    }

    export enum ClientAppointmentHistoryFilterType {
        All,
        Future,
        CheckedOut,
        Cancelled,
        NoShow,
        NoShowAndCancelled
    }

    export interface IPackageCriteria {
        client_TId: Guid;
        isExpired?: boolean;
        isRemaining?: boolean;
        isSplitMerged?: boolean;
        isExpiredOrRemaining?: boolean;
        isGlobal: boolean;
        locationId?: number;
        membershipPackagesOnly?: boolean;
    }

    export interface IPackageRequest {
        criteria: IPackageCriteria;
        pageNumber: number;
        itemsPerPage: number;
    }
    


}

